import React, { useContext, useState } from "react";
import { NewCitizenContext } from "../NewCitizenContext";
import { DownloadIdStepContainer } from "pages/Register/components/Register.styled";
import CustomPopup from "components/popup/Popup";

const IDCard = () => {
  const { IDCard, downloadCitizenID } = useContext(NewCitizenContext);
  const [showPopup, setShowPopup] = useState(true);

  const handleRedirect = () => {
    window.location.href = "https://serbisyongromualdez.com";
  };

  const closePopup = () => setShowPopup(false);

  const message = (
    <>
      Para sa karagdagang serbisyo, bisitahin ang{" "}
      <a
        href="https://serbisyongromualdez.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        serbisyongromualdez.com
      </a>
      , at ilagay ang iyong ID number sa referral code upang makakuha ng iba’t
      ibang benepisyo o tulong.
    </>
  );

  const handleRegisterAgain = () => {
    window.location.href = "/";
  };

  return (
    <DownloadIdStepContainer>
      {showPopup && (
        <CustomPopup
          message={message}
          onPrimary={handleRedirect}
          onSecondary={closePopup}
          primaryBtnText="OK"
          secondaryBtnText="Back"
        />
      )}

      <div className="content-container">
        <div className="text-content">
          <h2 className="header-text">
            Maraming Salamat sa pag-Rehistro sa Bagong Pilipinas!
          </h2>
          <p className="help-text">
            Narito ang iyong ID. Click the button below to{" "}
            <span className="help-text-download">download.</span>
          </p>
        </div>
        <img src={IDCard.url} className="id" />
        <button
          onClick={downloadCitizenID}
          className="download-id-btn"
          disabled={!IDCard.url}
        >
          Download
        </button>
        <button onClick={handleRegisterAgain} className="register-again-btn">
          Magparehistro muli
        </button>
      </div>
    </DownloadIdStepContainer>
  );
};

export default IDCard;
